import React from 'react'

import Button from 'components_new/atoms/Button'
import {
  calculateTotalAllocation,
  validateTotalAllocation
} from 'types/GlobalAllocationKey'
import Tooltip from 'components_new/atoms/Tooltip'
import Box from 'components_new/atoms/Box'
import { Strings, useTranslation } from 'language/translator'

interface IActionsProps {
  allocations: { [key: string]: string }
  nameInput: string
  isCreating: boolean
  onClose: () => void
  onCreate: () => void
  selectedAccounts: string[]
  step: number
  setStep: (step: number) => void
}

const Actions = (props: IActionsProps) => {
  const { t } = useTranslation()

  const validContinue = validateContinue(
    props.step,
    props.nameInput,
    props.selectedAccounts,
    props.allocations,
    t
  )

  return (
    <>
      <Button
        variant="text"
        disabled={props.isCreating}
        onClick={
          props.step === 1
            ? () => props.onClose()
            : () => props.setStep(props.step - 1)
        }
        size="large"
        sx={{ mr: 1 }}
      >
        {props.step === 1 ? t('global', 'close') : t('global', 'previous')}
      </Button>
      <Tooltip title={validContinue.tooltip}>
        <Box>
          <Button
            disabled={!validContinue.valid}
            loading={props.isCreating}
            onClick={
              props.step === 3
                ? () => props.onCreate()
                : () => props.setStep(props.step + 1)
            }
            size="large"
          >
            {props.step === 3 ? t('global', 'create') : t('global', 'next')}
          </Button>
        </Box>
      </Tooltip>
    </>
  )
}

function validateContinue(
  step: number,
  nameInput: string,
  selectedAccounts: string[],
  allocations: { [key: string]: string },
  t: (namespace: 'allocation_keys', key: Strings<'allocation_keys'>) => string
) {
  if (step === 1) {
    const valid = Boolean(nameInput)

    return {
      valid,
      tooltip: valid ? undefined : t('allocation_keys', 'empty_name_tooltip')
    }
  }

  if (step === 2) {
    const valid = selectedAccounts.length > 0

    return {
      valid,
      tooltip: valid
        ? undefined
        : t('allocation_keys', 'empty_accounts_tooltip')
    }
  }

  const validAllocation = validateTotalAllocation(
    calculateTotalAllocation(allocations),
    t
  )

  return {
    valid: validAllocation.validationPass,
    tooltip: validAllocation.tooltip
  }
}

export default Actions
